<mb-accelerator #accelerator color="notification">
    <mb-icon icon="info"></mb-icon>
        <mb-accelerator-title>
            <ng-container *ngIf="occupancy < 85; else highDemandTitle">
                <span i18n="@@few-offer__date-high-request">El destino está siendo muy solicitado para las fechas que estás buscando</span>
            </ng-container>
            <ng-template #highDemandTitle>
                <span i18n="@@few-offer__date-low-availability">Ya hay poca disponibilidad en el destino para las fechas que estás buscando</span>
            </ng-template>
        </mb-accelerator-title>
        <mb-accelerator-description>
            <ng-container *ngIf="occupancy < 85; else highDemandDescription">
                <span i18n="@@few-offer__book-accommodation-asap">¡Reservá tu alojamiento cuanto antes!</span>
            </ng-container>
            <ng-template #highDemandDescription>
                <span i18n="@@few-offer__book-before-out">¡Reservá antes que se agote!</span>
            </ng-template>
        </mb-accelerator-description>
</mb-accelerator>
